/* eslint-disable no-prototype-builtins */
import * as React from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'

import { positionChangeHeightSm, positionChangeWidthMd, positionChangeWidthSm, swipelyticsPink, profileTypes, profileVibes } from '../../../../helpers/variableDefaults'
import { standardButton, exitModalIconButton } from '../../../../helpers/buttons'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { newSimulationTextField } from '../../../../helpers/textfields'
import { validEmail, removeDuplicatesFromArray, noDuplicatesInArray, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { selectElementHandleChange, selectMultiple } from '../../../../helpers/selects'
import { doneAndCancelButtonsJSX } from '../../../../helpers/commonJSX'
import { advisoryTypography } from '../../../../helpers/typographies'
import { descriptionTextFieldNoIndexOrChangeHandler } from '../../../../helpers/textfields'

export const selectHobbyModalJSX = (
  user, 
  datingProfile, setDatingProfile, 
  previousDatingProfile, setPreviousDatingProfile, 
  selectedHobbyIndex, setSelectedHobbyIndex,
  newHobby, setNewHobby,
  openHobbySelectModal, setOpenHobbySelectModal,
  customHobbySelected, setCustomHobbySelected,
  loading, setLoading,
  errors, setErrors,
  saveSuccessful, setSaveSuccessful,
  width
) => {

  const arrayOfHobbies = removeDuplicatesFromArray([ 
    'No Hobby',
    ...user.bio.hobbies,
    'Custom'   
  ]).filter(hobbyString => hobbyString.length > 0)

  // console.log('selected hobby ->', datingProfile.bio.hobbies[selectedHobbyIndex])
  // console.log('length of selected hobby above 0', datingProfile.bio.hobbies[selectedHobbyIndex].length > 0)
  if ('hobbies' in datingProfile.bio && datingProfile.bio.hobbies[selectedHobbyIndex].length > 0 && arrayOfHobbies.filter((hobbyInArray, hobbyInArrayIndex) => hobbyInArray === datingProfile.bio.hobbies[selectedHobbyIndex]).length === 0) {
    arrayOfHobbies.splice(arrayOfHobbies.length - 1, 0, datingProfile.bio.hobbies[selectedHobbyIndex])
  }
  // console.log('arrayOfHobbies ->', arrayOfHobbies)

  const allDefaultHobbiesAreUsed = () => {
    if (
      user.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length > 0
      && datingProfile.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length > 0
    ) {
      for (let i = 0; i < user.bio.hobbies.length; i++) {
        if (!datingProfile.bio.hobbies.includes(user.bio.hobbies[i])) {
          return false
        }
      }
      return true
    } else if (
      user.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length > 0
    ) {
      return false
    } else if (
      datingProfile.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length > 0
    ) {
      return true
    } else {
      return true
    }
  }

  const handleClose = () => {
    // console.log('handleClose runs ->')
    // console.log('openHobbySelectModal ->', openHobbySelectModal)

    setNewHobby('')
    setSelectedHobbyIndex(-1)
    setCustomHobbySelected(false)
    setOpenHobbySelectModal(false)
  }

  const handleDone = async () => {
    console.log('handleDone runs')
    
    const newHobbies = [ ...datingProfile.bio.hobbies ]
    newHobbies[selectedHobbyIndex] = newHobby
    if (newHobbies[selectedHobbyIndex] === 'No Hobby' || newHobbies[selectedHobbyIndex] === '') {
      newHobbies.splice(selectedHobbyIndex, 1)
      newHobbies.push('')
    }
    const newBio = { ...datingProfile.bio, hobbies: [ ...newHobbies ] }
    setDatingProfile({ ...datingProfile, bio: { ...newBio } })

    setNewHobby('')
    setSelectedHobbyIndex(-1)
    setCustomHobbySelected(false)
    setOpenHobbySelectModal(false)
  }

  const selectHobby = (e, hobbyIndexOnArray) => {
    e.preventDefault()
    // console.log('selectHobby runs')

    if (arrayOfHobbies[hobbyIndexOnArray] !== 'Custom') {
      
      const newHobbies = [ ...datingProfile.bio.hobbies ]
      newHobbies[selectedHobbyIndex] = arrayOfHobbies[hobbyIndexOnArray] === 'No Hobby' ? '' : arrayOfHobbies[hobbyIndexOnArray]
      if (newHobbies[selectedHobbyIndex] === 'No Hobby' || newHobbies[selectedHobbyIndex] === '') {
        newHobbies.splice(selectedHobbyIndex, 1)
        newHobbies.push('')
      }
      const newBio = { ...datingProfile.bio, hobbies: [ ...newHobbies ] }
      setDatingProfile({ ...datingProfile, bio: { ...newBio } })

      setNewHobby('')
      setSelectedHobbyIndex(-1)
      setCustomHobbySelected(false)
      setOpenHobbySelectModal(false)
    } else {
      setNewHobby(datingProfile.bio.hobbies[selectedHobbyIndex])
      setCustomHobbySelected(true)
    }
  }

  const doneButtonDisabled = () => {
    return (
      datingProfile.bio.hobbies.length > selectedHobbyIndex
        ?
        newHobby === datingProfile.bio.hobbies[selectedHobbyIndex]
        :
        newHobby.length === 0
    )
  }

  const hobbyOnDatingProfile = (selectedHobby, selectedHobbyIndexOnArray) => {
    return datingProfile.bio.hobbies.filter((datingProfileHobby, datingProfileHobbyIndex) => datingProfileHobby === selectedHobby).length > 0
  }

  const hobbyIsSelected = (selectedHobbyIndexOnArray) => {
    return (
      newHobby === arrayOfHobbies[selectedHobbyIndexOnArray]
      || 
      (
        newHobby === ''
        && arrayOfHobbies[selectedHobbyIndexOnArray] === 'No Hobby'
      )
    )
  }

  const hobbyIsIndexSelected = (selectedHobby) => {
    return (
      selectedHobbyIndex < datingProfile.bio.hobbies.length
      && selectedHobby === datingProfile.bio.hobbies[selectedHobbyIndex]
    )
  }

  const hobbyItemsJSX = () => {
    return (
      <>
        {arrayOfHobbies.map((hobbyOnArray, hobbyIndexOnArray) => (
          <Box
            key={hobbyIndexOnArray}
            // onClick={(e) => selectHobby(e, hobbyIndexOnArray)}
            onClick={(hobbyOnDatingProfile(hobbyOnArray, hobbyIndexOnArray) && !(hobbyIsIndexSelected(hobbyOnArray))) ? ((e) => e) : ((e) => selectHobby(e, hobbyIndexOnArray))}
            disabled={hobbyOnDatingProfile(hobbyOnArray, hobbyIndexOnArray) && !(hobbyIsIndexSelected(hobbyOnArray))}
            sx={{
              mt: 2,
              width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
              backgroundColor: 'white',
              boxShadow: 3, 
              borderRadius: '5px',
              border: hobbyIsSelected(hobbyIndexOnArray) ? 2 : (hobbyOnDatingProfile(hobbyOnArray, hobbyIndexOnArray) && !(hobbyIsIndexSelected(hobbyOnArray))) ? 2 : 0,
              borderColor: hobbyIsSelected(hobbyIndexOnArray) ? 'blue' : (hobbyOnDatingProfile(hobbyOnArray, hobbyIndexOnArray) && !(hobbyIsIndexSelected(hobbyOnArray))) ? 'gray' : 'black',
              cursor: (hobbyOnDatingProfile(hobbyOnArray, hobbyIndexOnArray) && !(hobbyIsIndexSelected(hobbyOnArray))) || hobbyIsSelected(hobbyIndexOnArray) ? '' : 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            {/* Hobby */}
            <Typography
              sx={{
                px: 2, py: 1.5,
                width: '100%',
                // fontWeight: 'bold',
              }}
            >
              {hobbyOnArray}
            </Typography>
              
          </Box>
        ))}
      </>
    )
  }

  return (
    <Modal
      open={openHobbySelectModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box 
        sx={{ 
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          // width: width < positionChangeWidthSm ? '85%' : '450px',
          width: '85%',
          height: '85%',
          bgcolor: 'white',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4, 
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: 'rgba(0, 0, 0, .35)',
            webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%', height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {/* Exit Icon Button */}
          <Box
            sx={{
              mr: 0,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
            }}
          >
            {exitModalIconButton(handleClose, false, 0, 1, 1)}
          </Box>

          {/* Title */}
          <Typography
            sx={{
              mt: 2,
              fontSize: '22px',
              fontWeight: 'bold',
            }}
          >
            Select Hobby
          </Typography>

          <Box
            sx={{
              my: -2,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            {advisoryTypography(
              `'Hobby' elements can be edited in the 'Bio' tab of your dashboard`
            )}
          </Box>

          {/* List of Hobbies */}
          {!customHobbySelected
            &&
            (
              user.bio.hobbies.length > 0
              && user.bio.hobbies.filter((hobbyItem, hobbyItemIndex) => hobbyItem.length > 0).length > 0
            )
            && !allDefaultHobbiesAreUsed()
            ?
            hobbyItemsJSX()
            :
            <Box
              sx={{
                mt: 2,
                width: '90%',
                maxWidth: '450px',
              }}
            >
              {descriptionTextFieldNoIndexOrChangeHandler(
                'hobby',
                newHobby,
                ``,
                1,
                30,
                'Describe yourself in a few sentences',
                false,
                setNewHobby,
                newHobby,
                0
              )}
            </Box>
          }

          {/* Create and Cancel Buttons */}
          {doneAndCancelButtonsJSX(
            'Done',
            'Cancel',
            doneButtonDisabled(),
            false,
            handleDone,
            handleClose,
            0,
            0,
            0,
            width,
            'warning',
            'secondary'
          )}

          {errors.selectHobby &&
            standardErrorContainer(
              'There was an error updating your media item. Check your Internet connection and try again.',
              1,
              1
            )
          }
        </Box>
      </Box>
    </Modal>
  )
}